import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import NavBar, { NavBarItem } from "../../../components/NavBar";
import "./PrototypeShared.css";

interface Pendencia {
  referencia: string;
  cliente: string;
  tipo: "Sem original" | "Discrepância" | "Mercadoria perigosa (DGR)";
  diasPendente: number;
  aprovadoPor: string;
}

const pendencias: Pendencia[] = [
  { referencia: "REL-20791", cliente: "GE Celma Matriz", tipo: "Sem original", diasPendente: 42, aprovadoPor: "Carlos Eduardo Ramos" },
  { referencia: "REL-20802", cliente: "Baker Hughes", tipo: "Discrepância", diasPendente: 3, aprovadoPor: "Suzana Duarte" },
  { referencia: "REL-20815", cliente: "GE Power & Water", tipo: "Mercadoria perigosa (DGR)", diasPendente: 1, aprovadoPor: "Leticia Costa" },
  { referencia: "REL-20819", cliente: "GE Celma Matriz", tipo: "Sem original", diasPendente: 12, aprovadoPor: "Leticia Costa" },
];

const tipoStyle: Record<Pendencia["tipo"], string> = {
  "Sem original": "proto-pill-warn",
  "Discrepância": "proto-pill-danger",
  "Mercadoria perigosa (DGR)": "proto-pill-neutral",
};

/**
 * Protótipo da aposta 3: radar de compliance documental e DGR. AgreeDocsWithoutOriginal
 * e AgreeDocDiscrepancy já existem em Release; Dgr/DgrGoods já existem em Cargo - hoje
 * são só checkboxes no formulário, sem essa consolidação. Sem lógica de negócio nova.
 */
const ComplianceDgrView: React.FC = () => {
  const navItems: NavBarItem[] = [
    { label: "Início", route: "/", iconName: "house-door" },
    { label: "Iniciativas", route: "/iniciativas-estrategicas", iconName: "compass" },
  ];

  return (
    <Container fluid>
      <NavBar items={navItems} />
      <div className="mb-2"></div>

      <div className="proto-wrap">
        <Link to="/iniciativas-estrategicas" className="proto-back">← Iniciativas estratégicas</Link>

        <div className="proto-header">
          <div className="proto-badge">🧭 Protótipo — aposta 3 de 5</div>
          <h2>Radar de compliance documental e DGR</h2>
          <p className="proto-subtitle">
            Consolida "aceite sem original" (hoje 31,8% das liberações — ver Painel Executivo), discrepância
            documental e mercadoria perigosa num só lugar, com quem aprovou e há quanto tempo está pendente.
            Hoje isso não existe visualmente para ninguém, nem para o master.
          </p>
        </div>

        <div className="proto-section-title">Pendências em aberto</div>
        <div className="proto-mock">
          <div className="proto-mock-bar">
            <div className="proto-mock-dot"></div><div className="proto-mock-dot"></div><div className="proto-mock-dot"></div>
            <span className="proto-mock-title">giantlog.giantcargo.com.br/compliance-dgr</span>
          </div>
          <div className="proto-mock-body" style={{ padding: 0 }}>
            <table className="proto-table">
              <thead>
                <tr>
                  <th>Referência</th>
                  <th>Cliente</th>
                  <th>Tipo</th>
                  <th>Pendente há</th>
                  <th>Aprovado por</th>
                </tr>
              </thead>
              <tbody>
                {pendencias.map((p) => (
                  <tr key={p.referencia + p.tipo}>
                    <td style={{ fontFamily: "var(--mono)" }}>{p.referencia}</td>
                    <td>{p.cliente}</td>
                    <td><span className={`proto-pill ${tipoStyle[p.tipo]}`}>{p.tipo}</span></td>
                    <td>{p.diasPendente} dias</td>
                    <td>{p.aprovadoPor}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="proto-note">
          Dados ilustrativos. Fontes reais: Release.AgreeDocsWithoutOriginal, Release.AgreeDocDiscrepancy,
          Cargo.Dgr/DgrGoods — "pendente há" viria da mesma lógica de aging do Painel Executivo (KPI 08).
        </div>

        <div className="proto-footer-nav">
          <Link to="/iniciativas-estrategicas/portal-cliente">← Portal do cliente</Link>
          <Link to="/iniciativas-estrategicas/otimizacao-frete">Próxima: Otimização de frete →</Link>
        </div>
      </div>
    </Container>
  );
};

export default ComplianceDgrView;
